import { useMutation } from "@tanstack/react-query"
import { switchPlan, enableProPlan } from "sdk/billing"

export function useSwitchPlan(options = {}) {
  return useMutation({
    mutationFn: switchPlan,
    ...options
  })
}

export function useEnableProPlan(options = {}) {
  return useMutation({
    mutationFn: enableProPlan,
    ...options
  })
}
